import { render, staticRenderFns } from "./Urgency.vue?vue&type=template&id=c873ca5c&scoped=true"
import script from "./Urgency.vue?vue&type=script&lang=js"
export * from "./Urgency.vue?vue&type=script&lang=js"
import style0 from "./Urgency.vue?vue&type=style&index=0&id=c873ca5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c873ca5c",
  null
  
)

export default component.exports